import type { ReactNode } from 'react';
import SolarIcon from 'components/icons/SolarIcon';

interface TaskFilterPickerProps {
    open: boolean;
    hasValue: boolean;
    icon: string;
    pickLabel: string;
    cancelLabel: string;
    onOpen: () => void;
    onCancel: () => void;
    children: (cancelButton: ReactNode) => ReactNode;
}

const TaskFilterPicker = ({
    open,
    hasValue,
    icon,
    pickLabel,
    cancelLabel,
    onOpen,
    onCancel,
    children,
}: TaskFilterPickerProps) => {
    const cancelButton =
        open && !hasValue ? (
            <button
                type="button"
                className="btn btn-link p-0 align-baseline fs-12"
                onClick={onCancel}
            >
                {cancelLabel}
            </button>
        ) : null;

    return (
        <div className="mb-2">
            {hasValue || open ? (
                children(cancelButton)
            ) : (
                <button
                    type="button"
                    className="btn btn-link p-0 align-baseline fs-12"
                    onClick={onOpen}
                >
                    <SolarIcon name={icon} className="me-1" />
                    {pickLabel}
                </button>
            )}
        </div>
    );
};

export default TaskFilterPicker;
